// dependencies.
import { useState } from 'react'
import styled from 'styled-components'
// components.
import { Body } from '../Typography'
import { Button } from '../Button'
import { Input } from '../Form'
// utils.
import { useDimensions } from '../../js/hooks'
import notifyToast from '../../js/notifyToast'

// partials.
const Wrapper = styled.div({
  display: 'flex',
  flexDirection: (props) => (props.column ? 'column' : 'row'),
  gap: (props) => (props.isTablet ? '8px' : '16px'),
  width: (props) => (props.column ? '100%' : 'fit-content'),
})

const InputContainer = styled.div({
  display: 'flex',
  flexDirection: (props) => (props.column ? 'column' : 'row'),
  gap: 8,
  width: (props) => (props.column ? '100%' : 'fit-content'),
})

// main component.
const FilterDate = ({ label, onDateFilter = () => {}, defaultValue = {} }) => {
  const { isMobile, isTablet } = useDimensions()

  const [fromDate, setFromDate] = useState()
  const [toDate, setToDate] = useState()

  const handleFilterClick = () => {
    if (!fromDate || !toDate) {
      notifyToast('Debes seleccionar fecha desde y hasta', 'warn')
      return
    }

    const from = new Date(`${fromDate}T00:00:00`)
    const to = new Date(`${toDate}T23:59:59`)
    if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) {
      notifyToast('Rango de fechas inválido', 'warn')
      return
    }
    if (from > to) {
      notifyToast('La fecha desde no puede ser mayor a la fecha hasta', 'warn')
      return
    }

    const maxAllowedTo = new Date(from)
    maxAllowedTo.setMonth(maxAllowedTo.getMonth() + 12)
    if (to > maxAllowedTo) {
      notifyToast('El rango máximo permitido es de 12 meses', 'warn')
      return
    }

    onDateFilter(fromDate, toDate)
  }

  // return content.
  return (
    <Wrapper column={!!label} isTablet={isTablet}>
      {label && (
        <Body type="caption" color="grey">
          {label}
        </Body>
      )}
      <InputContainer column={!!label}>
        <Input
          name="fromDate"
          placeholder="Desde"
          showLabel
          defaultValue={defaultValue.fromDate}
          onChange={(value) => setFromDate(value)}
          type="date"
          max={new Date().toISOString().split('T')[0]}
        />
        <Input
          name="toDate"
          placeholder="Hasta"
          showLabel
          defaultValue={defaultValue.toDate}
          onChange={(value) => setToDate(value)}
          type="date"
          min={fromDate}
          max={new Date().toISOString().split('T')[0]}
        />
      </InputContainer>
      <Button isMobile={isMobile} onClick={handleFilterClick}>
        Filtrar fechas
      </Button>
    </Wrapper>
  )
}

export default FilterDate
